export const withOppositeAccessor = <T>(
    derive: (d: T) => number | undefined
) => [derive, (d: T) => -1 * (derive(d) || 0)];
